const style = (theme) => {
  const output = {
    root: {},
    themeDark: {
      color: theme.colors[2],
    },
    container: {
      extend: theme.wrapper,
      margin: '0 auto',
    },
    wrapper: {
      padding: '80px 0',
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
      paddingBottom: 12,
      marginBottom: 20,
      borderBottom: '1px solid currentColor',
    },
    grid: {
      fontSize: 14,
      lineHeight: 1.4,
      display: 'flex',
      justifyContent: 'space-between',
      '& p': {
        margin: 0,
      },
      '& > *': {
        width: 'calc((100% - 90px) / 4)',
        '& a': {
          marginLeft: 5,
          position: 'relative',
          color: 'currentColor',
          '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: 1,
            background: 'currentColor',
            bottom: 0,
            left: 0,
            transform: 'scaleX(0)',
            transformOrigin: 'left',
            transition: `transform 1s ${theme.easings['power4.out']}`,
          },
          '&:hover': {
            '&:before': {
              transform: 'scaleX(1)',
            },
          },
        },
      },
    },
    story: {
      fontSize: 10,
      lineHeight: 1.8,
    },
    copy: {
      fontWeight: 200,
      lineHeight: 1.5,
      fontSize: 14,
      '& p': {
        margin: 0,
      },
      '& p:not(:last-child)': {
        marginBottom: 20,
      },
      '& a': {
        color: 'currentColor',
        fontWeight: 500,
        '&:hover': {
          color: theme.getRgba(theme.colors[2], 0.5),
        },
      },
    },
    footerMenu: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      textAlign: 'right',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-12px',
        height: '100%',
        width: 1,
        background: theme.colors[0],
      },
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
    grid: {
      flexDirection: 'column',
      '& > *': {
        width: '100%',
        '& a': {
          marginLeft: 0,
        },
        '&:not(:last-child)': {
          marginBottom: 25,
        },
      },
    },
    footerMenu: {
      alignItems: 'flex-start',
    },
  }

  return output
}

export default style
